import axios from 'axios';
import type { AnnouncementFormData } from './types';

export const saveMessage = async (formData: AnnouncementFormData) => {
  await axios.post(`/message`, formData);
};
